  //Start Under The Banner Section JS
$(document).ready(function(){
$(".postworkout-icon").hover(function() {
  $('#postworkout-Tooltip').removeClass('hidden');
}, function() {
  $('#postworkout-Tooltip').addClass('hidden');
});

$(".intraworkout-icon").hover(function() {
  $('#intraworkout-Tooltip').removeClass('hidden');
}, function() {
  $('#intraworkout-Tooltip').addClass('hidden');
});

$(".anabolics-icon").hover(function() {
  $('#anabolics-Tooltip').removeClass('hidden');
}, function() {
  $('#anabolics-Tooltip').addClass('hidden');
});

$(".preworkout-icon").hover(function() {
  $('#preworkout-Tooltip').removeClass('hidden');
}, function() {
  $('#preworkout-Tooltip').addClass('hidden');
});

$(".commodities-icon").hover(function() {
  $('#commodities-Tooltip').removeClass('hidden');
}, function() {
  $('#commodities-Tooltip').addClass('hidden');
});

$(".weightmanagement-icon").hover(function() {
  $('#weightmanagement-Tooltip').removeClass('hidden');
}, function() {
  $('#weightmanagement-Tooltip').addClass('hidden');
});

$(".massgainers-icon").hover(function() {
  $('#massgainers-Tooltip').removeClass('hidden');
}, function() {
  $('#massgainers-Tooltip').addClass('hidden');
});

$(".sleepaid-icon").hover(function() {
  $('#sleepaid-Tooltip').removeClass('hidden');
}, function() {
  $('#sleepaid-Tooltip').addClass('hidden');
});

$(".generalhealth-icon").hover(function() {
  $('#generalhealth-Tooltip').removeClass('hidden');
}, function() {
  $('#generalhealth-Tooltip').addClass('hidden');
});

  });
// End Under The Banner Section JS
  //Start Products Info Icons Section JS
$(document).ready(function(){
$(".anabolics-info").hover(function() {
//   $('#anabolics-info').removeClass('hidden');
}, function() {
  $('#anabolics-info').addClass('hidden');
});

$(".commodities-info").hover(function() {
//   $('#commodities-info').removeClass('hidden');
}, function() {
  $('#commodities-info').addClass('hidden');
});

$(".post-workout-info").hover(function() {
//   $('#post-workout-info').removeClass('hidden');
}, function() {
  $('#post-workout-info').addClass('hidden');
});

$(".pre-workout-info").hover(function() {
//   $('#pre-workout-info').removeClass('hidden');
}, function() {
  $('#pre-workout-info').addClass('hidden');
});

$(".intra-workout-info").hover(function() {
//   $('#intra-workout-info').removeClass('hidden');
}, function() {
  $('#intra-workout-info').addClass('hidden');
});

$(".sleep-aid-info").hover(function() {
//   $('#sleep-aid-info').removeClass('hidden');
}, function() {
  $('#sleep-aid-info').addClass('hidden');
});

$(".weight-management-info").hover(function() {
//   $('#weight-management-info').removeClass('hidden');
}, function() {
  $('#weight-management-info').addClass('hidden');
});

$(".general-health-info").hover(function() {
//   $('#general-health-info').removeClass('hidden');
}, function() {
  $('#general-health-info').addClass('hidden');
});

$(".mass-gainers-info").hover(function() {
//   $('#mass-gainers-info').removeClass('hidden');
}, function() {
  $('#mass-gainers-info').addClass('hidden');
});
  
$(".lifeline").hover(function() {
//   $('#mass-gainers-info').removeClass('hidden');
}, function() {
  $('#lifeline').addClass('hidden');
});
// $(".joints").hover(function() {
//   $('#joints').removeClass('hidden');
// }, function() {
//   $('#joints').addClass('hidden');
// });

// $(".health").hover(function() {
//   $('#health').removeClass('hidden');
// }, function() {
//   $('#health').addClass('hidden');
// });
// Start Tags Size on Product dinamicaly JS
//   if( $( ".tags-info .box-tags" ).length <= 3){
//     $(".box-tags").css({'float':'left'});
//     $(".box-tags a").css('margin','auto');
//   }else if( $( ".tags-info .box-tags" ).length <= 4){
//     $(".box-tags").css({'float':'left'});
//     $(".box-tags a").css('margin','auto');
//   }else if( $( ".tags-info .box-tags" ).length <= 5){
//     $(".box-tags").css({"float":"left"});
//   }else{
//   	 $(".box-tags").css({'float':'left'});
//   }

  $(".box-tags").has(".pre-workout").remove();
  $(".box-tags").has(".supplements").remove();
  $(".box-tags").has(".anabolics").remove();
  $(".box-tags").has(".intra-workout").remove();
  $(".box-tags").has(".sleep").remove();
  $(".box-tags").has(".thermogenics").remove();
  $(".box-tags").has(".joint").remove();
  $(".box-tags").has(".post-workout").remove();
  $(".box-tags").has(".protein").remove();

  function resizeParallax(){
    var width = $(this).width()* 3;
    if($(window).width() > 1025){
      $('#shopify-section-1580732905014 .parallax-img').css('height',width/8-141)
    }else if($(window).width()< 1025){
      $('#shopify-section-1580732905014 .parallax-img').css('height',width/8-65)
    }
    }
  function scrollParallax(x){
   var x = $(this).scrollTop()*-1;
    var width = $(this).width()* 3;
     if($(window).width() > 1400){
     var y = parseInt(x / 1.2 + 1988);
    $('#shopify-section-1580732905014 .parallax-img').css('background-position', '50% ' + y + 'px');
   }else if($(window).width()< 1400  && $(window).width() > 1300){
     var y = parseInt(x / 1.2 + 1845);
    $('#shopify-section-1580732905014 .parallax-img').css('background-position', '50% ' + y + 'px');
    }else if($(window).width()< 1300  && $(window).width() > 1200){
     var y = parseInt(x / 1.2 + 1840);
    $('#shopify-section-1580732905014 .parallax-img').css('background-position', '50% ' + y + 'px');
    }else if($(window).width()< 1201 && $(window).width() > 1125){
     var y = parseInt(x / 1.15 + 1740);
    $('#shopify-section-1580732905014 .parallax-img').css('background-position', '50% ' + y + 'px');
    }else if($(window).width()< 1125 && $(window).width() > 1025){
     var y = parseInt(x / 1.15 + 1655);
    $('#shopify-section-1580732905014 .parallax-img').css('background-position', '50% ' + y + 'px');
    }else if($(window).width()< 1025){
     var y = parseInt(x / 1 + 2285);
      $('#shopify-section-1580732905014 .parallax-img').css({'background-attachment':'unset','background-size':'100%','background-position':'50% 0px'});
      
    }
   }
    $(window).resize(function(){
      resizeParallax()
  });
  $( window ).scroll(function() {
   scrollParallax()
  });
  resizeParallax();
  });
// End Tags Size on Product dinamicaly JS
  //End Products Info Icons Section JS
$(document).ready(function(){
  // Start Copyright Dinamyc time change JS
   var currentYear = (new Date).getFullYear();
   $('.copy-year').html(currentYear);
// End Copyright Dinamyc time change JS
// Start Breadcrumb JS
  var slogan = $('.bredcrumbWrap .slogan'); 
  if(slogan.length > 0){
  	$('.bredcrumbWrap .breadcrumbs').css('marginTop', '36px');
  }else{
  $('.bredcrumbWrap .breadcrumbs').css('marginTop', '0px');
  }
//Start Adding ID on body from the url JS  
var url = $(location).attr('href');
   if (window.location.href.indexOf("?") > -1) {
      url = url.substring(0 , url.indexOf('?'));
    }
  if (window.location.href.indexOf("#") > -1) {
      url = url.substring(0 , url.indexOf('#'));
    }
    parts = url.split("/");
    last_part = parts[parts.length-1];
  $('body').attr('id',last_part); 
  $('#recipes-newsite .topSpace').remove();
//End Adding ID on body from the url JS
// End Breadcrumb JS
function keepLocation(oldOffset) {
  if (window.pageYOffset!= null){
    st=oldOffset;
  }
  if (document.body.scrollWidth!= null){
    st=oldOffset;
  }
  setTimeout('window.scrollTo(0,st)',10);
}
  })


//Start Categories Logos under the banner JS


/*
function postworkouthover(element) {
  element.setAttribute('src', 'https://cdn.shopify.com/s/files/1/2440/0931/files/new-icons-POSTWORKOUT.png?v=1592832659');
}

function postworkoutunhover(element) {
  element.setAttribute('src', 'https://cdn.shopify.com/s/files/1/2440/0931/files/black-icons-POSTWORKOUT.png?v=1597047083');
}

function intraworkouthover(element) {
  element.setAttribute('src', 'https://cdn.shopify.com/s/files/1/2440/0931/files/white-icons-INTRA.png?v=1599638891');
}

function intraworkoutunhover(element) {
  element.setAttribute('src', 'https://cdn.shopify.com/s/files/1/2440/0931/files/black-icons-INTRA.png?v=1597047083');
}

function anabolicshover(element) {
  element.setAttribute('src', 'https://cdn.shopify.com/s/files/1/2440/0931/files/white-icons-ANABOLICS.png?v=1599638892');
}

function anabolicsunhover(element) {
  element.setAttribute('src', 'https://cdn.shopify.com/s/files/1/2440/0931/files/black-icons-ANABOLICS.png?v=1597047083');
}

function preworkouthover(element) {
  element.setAttribute('src', 'https://cdn.shopify.com/s/files/1/2440/0931/files/white-icons-PREWORKOUT.png?v=1599638891');
}

function preworkoutunhover(element) {
  element.setAttribute('src', 'https://cdn.shopify.com/s/files/1/2440/0931/files/black-icons-PREWORKOUT.png?v=1597047083');
}

function commoditieshover(element) {
  element.setAttribute('src', 'https://cdn.shopify.com/s/files/1/2440/0931/files/white-icons-COMMODITIES.png?v=1599638891');
}

function commoditiesunhover(element) {
  element.setAttribute('src', 'https://cdn.shopify.com/s/files/1/2440/0931/files/black-icons-COMMODITIES.png?v=1597047083');
}

function weightmanagementhover(element) {
  element.setAttribute('src', 'https://cdn.shopify.com/s/files/1/2440/0931/files/white-icons-WEIGHT.png?v=1599638891');
}

function weightmanagementunhover(element) {
  element.setAttribute('src', 'https://cdn.shopify.com/s/files/1/2440/0931/files/black-icons-WEIGHT.png?v=1597047083');
}

function massgainershover(element) {
  element.setAttribute('src', 'https://cdn.shopify.com/s/files/1/2440/0931/files/white-icons-MASSGAINERS.png?v=1599638891');
}

function massgainersunhover(element) {
  element.setAttribute('src', 'https://cdn.shopify.com/s/files/1/2440/0931/files/black-icons-MASSGAINERS.png?v=1597047083');
}

function sleepaidhover(element) {
  element.setAttribute('src', 'https://cdn.shopify.com/s/files/1/2440/0931/files/white-icons-SLEEPAID.png?v=1599638891');
}

function sleepaidunhover(element) {
  element.setAttribute('src', 'https://cdn.shopify.com/s/files/1/2440/0931/files/black-icons-SLEEPAID.png?v=1597047083');
}

function generalhealthhover(element) {
  element.setAttribute('src', 'https://cdn.shopify.com/s/files/1/2440/0931/files/white-icons-GENERAL.png?v=1599638891');
}

function generalhealthunhover(element) {
  element.setAttribute('src', 'https://cdn.shopify.com/s/files/1/2440/0931/files/black-icons-GENERAL.png?v=1597047083');
}
function aestheticshover(element) {
  element.setAttribute('src', 'https://cdn.shopify.com/s/files/1/2440/0931/files/white-icons-AESTHETICS.png?v=1695635303');
}

function aestheticsunhover(element) {
  element.setAttribute('src', 'https://cdn.shopify.com/s/files/1/2440/0931/files/black-icons-AESTHETICS.png?v=1695635001');
}
function ballshover(element) {
  element.setAttribute('src', 'https://cdn.shopify.com/s/files/1/2440/0931/files/white-icons-BALLS.png?v=1607879886');
}
function ballsunhover(element) {
  element.setAttribute('src', 'https://cdn.shopify.com/s/files/1/2440/0931/files/black-icons-BALLS.png?v=1607879260');
}

function lifelinehover(element) {
  element.setAttribute('src', 'https://cdn.shopify.com/s/files/1/2440/0931/files/white-icons-LIFELINE.png?v=1633336554');
}
function lifelineunhover(element) {
  element.setAttribute('src', 'https://cdn.shopify.com/s/files/1/2440/0931/files/black-icons-LIFELINE.png?v=1633335806');
}
*/

//End Categories Logos under the banner JS

$('.nav-tabs #usa-tab').click(function(){
  $('.tab-content .usa-tab').addClass('active');
  $('.tab-content .uk-tab').removeClass('active');
  $('.tab-content .canada-tab').removeClass('active');
  $('.tab-content .australia-tab').removeClass('active');
  $('.tab-content .distributors-tab').removeClass('active');
  $('.tab-content .south_africa-tab').removeClass('active');
  $('.tab-content .singapore-tab').removeClass('active');
  $('.tab-content .hong_kong-tab').removeClass('active');
  
  $('.nav-tabs #usa-tab').addClass('active');
  $('.nav-tabs #uk-tab').removeClass('active');
  $('.nav-tabs #canada-tab').removeClass('active');
  $('.nav-tabs #australia-tab').removeClass('active');
  $('.nav-tabs #distributors-tab').removeClass('active');
  $('.nav-tabs #south_africa-tab').removeClass('active');
  $('.nav-tabs #singapore-tab').removeClass('active');
  $('.nav-tabs #hong_kong-tab').removeClass('active');
});
$('.nav-tabs #uk-tab').click(function(){
  $('.tab-content .usa-tab').removeClass('active');
  $('.tab-content .uk-tab').addClass('active');
  $('.tab-content .canada-tab').removeClass('active');
  $('.tab-content .australia-tab').removeClass('active');
  $('.tab-content .distributors-tab').removeClass('active');
    $('.tab-content .south_africa-tab').removeClass('active');
  $('.tab-content .singapore-tab').removeClass('active');
  $('.tab-content .hong_kong-tab').removeClass('active');
  
  $('.nav-tabs #usa-tab').removeClass('active');
  $('.nav-tabs #uk-tab').addClass('active');
  $('.nav-tabs #canada-tab').removeClass('active');
  $('.nav-tabs #australia-tab').removeClass('active');
  $('.nav-tabs #distributors-tab').removeClass('active');
    $('.nav-tabs #south_africa-tab').removeClass('active');
  $('.nav-tabs #singapore-tab').removeClass('active');
  $('.nav-tabs #hong_kong-tab').removeClass('active');
});
$('.nav-tabs #canada-tab').click(function(){
  $('.tab-content .usa-tab').removeClass('active');
  $('.tab-content .uk-tab').removeClass('active');
  $('.tab-content .canada-tab').addClass('active');
  $('.tab-content .australia-tab').removeClass('active');
  $('.tab-content .distributors-tab').removeClass('active');
    $('.tab-content .south_africa-tab').removeClass('active');
  $('.tab-content .singapore-tab').removeClass('active');
  $('.tab-content .hong_kong-tab').removeClass('active');
  
  $('.nav-tabs #usa-tab').removeClass('active');
  $('.nav-tabs #uk-tab').removeClass('active');
  $('.nav-tabs #canada-tab').addClass('active');
  $('.nav-tabs #australia-tab').removeClass('active');
  $('.nav-tabs #distributors-tab').removeClass('active');
    $('.nav-tabs #south_africa-tab').removeClass('active');
  $('.nav-tabs #singapore-tab').removeClass('active');
  $('.nav-tabs #hong_kong-tab').removeClass('active');
});
$('.nav-tabs #australia-tab').click(function(){
  $('.tab-content .usa-tab').removeClass('active');
  $('.tab-content .uk-tab').removeClass('active');
  $('.tab-content .canada-tab').removeClass('active');
  $('.tab-content .australia-tab').addClass('active');
  $('.tab-content .distributors-tab').removeClass('active');
    $('.tab-content .south_africa-tab').removeClass('active');
  $('.tab-content .singapore-tab').removeClass('active');
  $('.tab-content .hong_kong-tab').removeClass('active');
  	
  $('.nav-tabs #usa-tab').removeClass('active');
  $('.nav-tabs #uk-tab').removeClass('active');
  $('.nav-tabs #canada-tab').removeClass('active');
  $('.nav-tabs #australia-tab').addClass('active');
  $('.nav-tabs #distributors-tab').removeClass('active');
    $('.nav-tabs #south_africa-tab').removeClass('active');
  $('.nav-tabs #singapore-tab').removeClass('active');
  $('.nav-tabs #hong_kong-tab').removeClass('active');
});
$('.nav-tabs #distributors-tab').click(function(){
  $('.tab-content .usa-tab').removeClass('active');
  $('.tab-content .uk-tab').removeClass('active');
  $('.tab-content .canada-tab').removeClass('active');
  $('.tab-content .australia-tab').removeClass('active');
  $('.tab-content .distributors-tab').addClass('active');
    $('.tab-content .south_africa-tab').removeClass('active');
  $('.tab-content .singapore-tab').removeClass('active');
  $('.tab-content .hong_kong-tab').removeClass('active');
  
  $('.nav-tabs #usa-tab').removeClass('active');
  $('.nav-tabs #uk-tab').removeClass('active');
  $('.nav-tabs #canada-tab').removeClass('active');
  $('.nav-tabs #australia-tab').removeClass('active');
  $('.nav-tabs #distributors-tab').addClass('active');
    $('.nav-tabs #south_africa-tab').removeClass('active');
  $('.nav-tabs #singapore-tab').removeClass('active');
  $('.nav-tabs #hong_kong-tab').removeClass('active');
});

$('.nav-tabs #hong_kong-tab').click(function(){
  $('.tab-content .usa-tab').removeClass('active');
  $('.tab-content .uk-tab').removeClass('active');
  $('.tab-content .canada-tab').removeClass('active');
  $('.tab-content .australia-tab').removeClass('active');
  $('.tab-content .distributors-tab').removeClass('active');
    $('.tab-content .south_africa-tab').removeClass('active');
  $('.tab-content .singapore-tab').removeClass('active');
  $('.tab-content .hong_kong-tab').addClass('active');
  
  $('.nav-tabs #usa-tab').removeClass('active');
  $('.nav-tabs #uk-tab').removeClass('active');
  $('.nav-tabs #canada-tab').removeClass('active');
  $('.nav-tabs #australia-tab').removeClass('active');
  $('.nav-tabs #distributors-tab').removeClass('active');
    $('.nav-tabs #south_africa-tab').removeClass('active');
  $('.nav-tabs #singapore-tab').removeClass('active');
  $('.nav-tabs #hong_kong-tab').addClass('active');
});

$('.nav-tabs #south_africa-tab').click(function(){
  $('.tab-content .usa-tab').removeClass('active');
  $('.tab-content .uk-tab').removeClass('active');
  $('.tab-content .canada-tab').removeClass('active');
  $('.tab-content .australia-tab').removeClass('active');
  $('.tab-content .distributors-tab').removeClass('active');
    $('.tab-content .south_africa-tab').addClass('active');
  $('.tab-content .singapore-tab').removeClass('active');
  $('.tab-content .hong_kong-tab').removeClass('active');
  
  $('.nav-tabs #usa-tab').removeClass('active');
  $('.nav-tabs #uk-tab').removeClass('active');
  $('.nav-tabs #canada-tab').removeClass('active');
  $('.nav-tabs #australia-tab').removeClass('active');
  $('.nav-tabs #distributors-tab').removeClass('active');
    $('.nav-tabs #south_africa-tab').addClass('active');
  $('.nav-tabs #singapore-tab').removeClass('active');
  $('.nav-tabs #hong_kong-tab').removeClass('active');
});

$('.nav-tabs #singapore-tab').click(function(){
  $('.tab-content .usa-tab').removeClass('active');
  $('.tab-content .uk-tab').removeClass('active');
  $('.tab-content .canada-tab').removeClass('active');
  $('.tab-content .australia-tab').removeClass('active');
  $('.tab-content .distributors-tab').removeClass('active');
    $('.tab-content .south_africa-tab').removeClass('active');
  $('.tab-content .singapore-tab').addClass('active');
  $('.tab-content .hong_kong-tab').removeClass('active');
  
  $('.nav-tabs #usa-tab').removeClass('active');
  $('.nav-tabs #uk-tab').removeClass('active');
  $('.nav-tabs #canada-tab').removeClass('active');
  $('.nav-tabs #australia-tab').removeClass('active');
  $('.nav-tabs #distributors-tab').removeClass('active');
    $('.nav-tabs #south_africa-tab').removeClass('active');
  $('.nav-tabs #singapore-tab').addClass('active');
  $('.nav-tabs #hong_kong-tab').removeClass('active');
});





$(document).ready(function(){
  $('.trigger-modal').click(function(){
    var modal = new theme.Modals($(this).attr('data-target'), $(this).attr('data-target')+'--modal');
    
    modal.open();
  })
  $('.bundle-add-to-cart').click(function(){
    var variant_id = $(this).attr('data-target-id');
    var elem = $(this);
    $(this).addClass('btn--loading')
    setTimeout(function(){
      var data = {
        "quantity": 1,
        "id": variant_id,
      }
      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        async: false,
        data: data,
        dataType: 'json',
        success: function() {
          $('.bundle-add-to-cart').removeClass('btn--loading')
          elem.text('Added to cart').addClass('disabled-btn');
        },
        error:function(err){
          $('.bundle-add-to-cart').removeClass('btn--loading');
        }
      });
    },300)
  })

  $('.all-bundle-cart').click(function(e){
    e.preventDefault();
    var selected_variants = [];
    $('.options-bundle-wrapper').each(function(){
      if(!$(this).hasClass('no-variant')){
        var variant_title = '';
        $(this).find('input:checked').each(function(){
          variant_title += $(this).val();
        })
        $(this).prev('.hidden-variants').find('option').each(function(){
          if($(this).text() == variant_title){
            selected_variants.push($(this).attr('value'));
          }
        })
      }
      else{
        selected_variants.push($(this).attr('data-variant-id'));
      }
    })
    $(this).addClass('btn--loading')
    bundleAddToCart(selected_variants,$(this));
  })
  $('.buy-bundle').click(function(e){
    e.preventDefault();
    $(this).addClass('btn--loading');
    var selected_variants = $(this).attr('data-id').split(',');
   	bundleAddToCart(selected_variants,$(this));
  })
  function bundleAddToCart(variant_ids,elem){
    var numberOfPendingRequests = 0;
    setTimeout(function(){
      for(var i=0;i<variant_ids.length;i++){
        var variant =  parseInt(variant_ids[i]);
        if(variant != undefined)
        {
          numberOfPendingRequests++;
        }
      }
      for(var i=0;i<variant_ids.length;i++){
        var variant = parseInt(variant_ids[i]);
        var qnt_value = 1;
        if(variant != undefined)
        {
          var data = {
            "quantity": qnt_value,
            "id": variant,
          }
          jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            async: false,
            data: data,
            dataType: 'json',
            success: function() {
              numberOfPendingRequests --;
              if(numberOfPendingRequests == 0)
              {
                window.location.href='/cart';
                elem.removeClass('btn--loading')
              }
            },
            error:function(){
              numberOfPendingRequests --;
              if(numberOfPendingRequests == 0)
              {
                window.location.href='/cart';
                elem.removeClass('btn--loading')
              }
            }
          });

        }
      }
    },500)
  }
  $('.product-label-modal').click(function(){
    var selected = '';
    $('.variant-input-wrap').each(function(){
      selected += $(this).find('input:checked').attr('data-handle');
    })
    $('.metafield-label-image').hide();
    $('.label-'+selected).show();
    new theme.Photoswipe($('.product-labels-wrapper'), 'product-label-popup');
  })
//    $('.bundle-thumb-slider').slick({
//     asNavFor: '.bundle-main-slider',
//     adaptiveHeight: true,
//     dots: false,
//     infinite: false,
//     fade: true,
//          vertical: true,
//     verticalSwiping: true
//   })
//   $('.bundle-main-slider').slick({
//     asNavFor: '.bundle-thumb-slider',
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: false,
//     dots: false,

//     focusOnSelect: true,
//     infinite: false,
//     customHeightMatching:false,
//     customSlideAdvancement: false
//   })
 })
  $('.options-bundle-wrapper .variant__label').html(function(index, text) {
  return text.replace("Color", "");
});  
$(document).ready(function(){
	$('#core-nutritionals-raglan-t-shirt .all-bundle-cart').html('Add to Cart')
    $('#core-nutritionals-gear-hoodie .all-bundle-cart').html('Add to Cart')
    $('#new-mens-lightweight-crush-it-performance-hoodie .all-bundle-cart').html('Add to Cart')
})


/* START Cart Modal JS by Royal Weblab  10.12.2021*/
// Get the modal
// var modal = document.getElementById("myModal");

// Get the button that opens the modal
// var btn = document.getElementById("myBtn");

// Get the <span> element that closes the modal
// var span = document.getElementsByClassName("close")[0];

// When the user clicks on the button, open the modal
// btn.onclick = function() {
//   modal.style.display = "block";
// }

// When the user clicks on <span> (x), close the modal
// span.onclick = function() {
//   modal.style.display = "none";
// }

// When the user clicks anywhere outside of the modal, close it
// window.onclick = function(event) {
//   if (event.target == modal) {
//     modal.style.display = "none";
//   }
// }
/* END Cart Modal JS by Royal Weblab  10.12.2021*/

// START Add to Cart on Collections/Home page JS
$(document).ready(function(){
  $('.grid-view-item').each(function(){
  	var productID = $(this).attr('id');
    
    $('#'+ productID +' .swatch').on('click', function() {
   			$('#'+ productID +' .button-set .btn-options').attr('href','/cart/add?id='+$(this).attr('id')+'&quantity=1');
      if($(this).attr('id') == "soldout"){
        $('#'+ productID +' .button-set .btn-options').attr('style','display:none');
      }else{
      	$('#'+ productID +' .button-set .btn-options').removeAttr('style');
      }
    });
  })
  		
});
// END Add to Cart on Collections/Home page JS
$(document).ready(function(){
  // START Separate variants of multiple products JS by Royal Weblab
	var item = $('#pre-intra-post .options-bundle-wrapper .variant-input');

  item.each(function(){
    var itemVal = $(this).attr('data-value');
    var productName = itemVal.split('-')[0];
    var classLowerCase = productName.toLowerCase();
    $(this).addClass(classLowerCase);
  })
  	
  var pump = $('#pre-intra-post .options-bundle-wrapper .pump');
  pump.wrapAll('<div class="pump-container"></div>');  
  $('.pump-container').prepend(`<h3>PUMP</h3>`);
  
  var fury = $('#pre-intra-post .options-bundle-wrapper .fury');
  fury.wrapAll('<div class="fury-container"></div>');  
  $('.fury-container').prepend(`<h3>FURY</h3>`);
  
  var furyAustralian = $('#pre-intra-post .options-bundle-wrapper .fury.australian');
  furyAustralian.wrapAll('<div class="fury-australian-container"></div>');  
  $('.fury-australian-container').prepend(`<h3>FURY AUSTRALIAN</h3>`);
  
  var abc = $('#pre-intra-post .options-bundle-wrapper .abc');
  abc.wrapAll('<div class="abc-container"></div>');  
  $('.abc-container').prepend(`<h3>ABC</h3>`);
  
  var intra = $('#pre-intra-post .options-bundle-wrapper .intra');
  intra.wrapAll('<div class="intra-container"></div>');  
  $('.intra-container').prepend(`<h3>INTRA</h3>`);
  
  var post = $('#pre-intra-post .options-bundle-wrapper .post');
  post.wrapAll('<div class="post-container"></div>');  
  $('.post-container').prepend(`<h3>POST</h3>`);
  
  var iso = $('#pre-intra-post .options-bundle-wrapper .iso');
  iso.wrapAll('<div class="iso-container"></div>');  
  $('.iso-container').prepend(`<h3>ISO</h3>`);
// END Separate variants of multiple products JS by Royal Weblab
//   START Coupon hide if product is in the cart by Royal Weblab
// setTimeout(function() {
//   $('.saso-cart-item-discount-notes').each(function(){
//     	var item = $(this).attr('data-key');	
//     	if(item == '41765500485808:1083feb3d7478d2e4ce25a95b9d96324'){
//     		$('.saso-use-discount-code-cart-container').css('display','none');
//           console.log('true')
//         } else {
//         	console.log('false')
//         }
    
//     });
// }, 6000);
//   End Coupon hide if product is in the cart by Royal Weblab
// START add text info about swatches JS by Royal Weblab
$('.variant-input-wrap').before(`<p class="swatch-info">*Tap/Hover on the box to see the name of the flavor/product</p>`)
$('.swatch .product-form__item').append(`<p class="swatch-info">*Tap/Hover on the box to see the name of the flavor/product</p>`)
// END add text info about swatches JS by Royal Weblab
    // Add smooth scrolling to all links
  $(".scroll-arrows").on('click', function(event) {

    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      var hash = this.hash;

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 800, function(){
   
        // Add hash (#) to URL when done scrolling (default click behavior)
        window.location.hash = hash;
      });
    } // End if
  });
});

  // START Code from outside link because was blocking the website from fast loading and is copied here until we find a solution (tagcontainer.js) JS by Royal Weblab
function loadScripts() {
   var script = document.createElement('script');
   script.src = 'https://js.b1js.com/tagcontainer.js?id=31dae68e8eb743a8a189e3fddf6f5d55&type=1&onload=false';
   var body = document.getElementsByTagName("body")[0];
   body.appendChild(script);
}

setTimeout(loadScripts, 5000);
// END
